var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateInputSuffix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1.87695H10.125V0.876953C10.125 0.808203 10.0688 0.751953 10 0.751953H9.125C9.05625 0.751953 9 0.808203 9 0.876953V1.87695H5V0.876953C5 0.808203 4.94375 0.751953 4.875 0.751953H4C3.93125 0.751953 3.875 0.808203 3.875 0.876953V1.87695H1.25C0.973438 1.87695 0.75 2.10039 0.75 2.37695V12.752C0.75 13.0285 0.973438 13.252 1.25 13.252H12.75C13.0266 13.252 13.25 13.0285 13.25 12.752V2.37695C13.25 2.10039 13.0266 1.87695 12.75 1.87695ZM12.125 12.127H1.875V6.18945H12.125V12.127ZM1.875 5.12695V3.00195H3.875V3.75195C3.875 3.8207 3.93125 3.87695 4 3.87695H4.875C4.94375 3.87695 5 3.8207 5 3.75195V3.00195H9V3.75195C9 3.8207 9.05625 3.87695 9.125 3.87695H10C10.0688 3.87695 10.125 3.8207 10.125 3.75195V3.00195H12.125V5.12695H1.875Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateInputSuffix);
export default __webpack_public_path__ + "static/media/dateInputSuffix.6ce2b2189dc06fa3f50f8ef8fefe53b4.svg";
export { ForwardRef as ReactComponent };